<template>
  <div class="profile-container">
    <div class="bio-section">
      <BioSection :accessProfile="accessProfile" />
    </div>
    <div class="kits-section" v-if="accessProfile || kitsOwned">
      <KitsSection :accessProfile="accessProfile" />
    </div>
    <div class="line" />
    <div class="persona-section" v-if="(accessProfile || profileData.persona_code != null) && profileData.user_type == 'student'">
      <PersonaSection :accessProfile="accessProfile" />
    </div>
  </div>
</template>

<script>
import {  mapGetters } from "vuex";
import BioSection from "./micro-components/Bio.vue";
import KitsSection from "./micro-components/Kits.vue";
import PersonaSection from "./micro-components/Persona.vue";
export default {
  name: "Bio-tab",
  components: {
    BioSection,
    KitsSection,
    PersonaSection,
  },
  data(){
    return {
      accessProfile: true
    }
  },
  computed: {
    ...mapGetters({ profileData: "getUserProfileData", kitsOwned: "getKitsOwned"}),
  },
  created() {
    if(this.$route.params.userName != undefined){
      this.accessProfile = false
    }
  }
};
</script>

<style>
.v-overlay {
  z-index: 1031!important;
}
.v-dialog__content {
  z-index: 1032!important;
}
.v-dialog {
  margin: 0;
}
</style>

<style lang="scss" scoped>
.profile-container {
  .bio-section {
    width: 100%;
    height: 60vh;
  }
  .kits-section {
    width: 100%;
  }
  .persona-section {
    width: 100%;
  }
}
.line {
  width: 100%;
  height: 1px;
  background-color: rgb(0,0,0,0.07);
}
@media all and (max-width: 700px) {
  .profile-container {
    .bio-section {
      height: 83vh;
    }
  }
}
</style>